import React from 'react';
import { Search } from 'lucide-react';

interface CompactTableToolbarProps {
  searchValue?: string;
  searchPlaceholder?: string;
  searchLabel?: string;
  onSearchChange?: (value: string) => void;
  filters?: React.ReactNode;
  actions?: React.ReactNode;
  resultCount?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
}

const joinClasses = (...classes: Array<string | undefined | false>) =>
  classes.filter(Boolean).join(' ');

const CompactTableToolbar: React.FC<CompactTableToolbarProps> = ({
  searchValue,
  searchPlaceholder = 'Search records',
  searchLabel = 'Search records',
  onSearchChange,
  filters,
  actions,
  resultCount,
  children,
  className,
}) => (
  <div className={joinClasses('compact-table-toolbar', className)}>
    {onSearchChange ? (
      <label className="compact-table-search">
        <span className="sr-only">{searchLabel}</span>
        <Search size={15} aria-hidden="true" />
        <input
          type="search"
          value={searchValue || ''}
          placeholder={searchPlaceholder}
          onChange={(event) => onSearchChange(event.target.value)}
        />
      </label>
    ) : null}
    {filters || children ? (
      <div className="compact-table-filters">
        {filters}
        {children}
      </div>
    ) : null}
    {resultCount ? <span className="compact-table-count">{resultCount}</span> : null}
    {actions ? <div className="compact-table-actions">{actions}</div> : null}
  </div>
);

export default CompactTableToolbar;
